import DashboardLayout from "layouts/DashboardLayout";
import React, { useEffect, useState } from "react";
import { AppTable, SearchInput } from "components";
import { TableBodyContent } from "components/AppTable";
import { Router } from "utils/route";
import { ApiService } from "services";
import { toast } from "react-hot-toast";
import { userData } from "utils/userData";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import Skeleton2 from "components/Skeleton2";
import TabButton from "components/TabButton";
//import { add } from "assets/icons";

export default function AuditTrail({ title }) {
  const [loading, setLoading] = useState(false);

  const [searchInput, setSearchInput] = useState("");

  const [admins, setAdmins] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [others, setOthers] = useState([]);

  console.log(admins);
  //eslint-disable-next-line
  const [id, setId] = useState();

  const getAdmins = async (id) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2" ||
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "nonBankAdmin"
    ) {
      setLoading(true);
      try {
        const data = await ApiService.getAdminsAudit(id);
        console.log(data);
        setAdmins(data?.data);
        setLoading(false);

        console.log(data);
      } catch (err) {
        console.log(err);
        setLoading(false);

        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const getAuditOthers = async () => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2" ||
      userData?.userDetail?.role === "bankAdmin" ||
      userData?.userDetail?.role === "nonBankAdmin"
    ) {
      setLoading(true);
      try {
        const data = await ApiService.getOthersAuditTrail();
        console.log(data);
        setOthers(data?.data);
        setLoading(false);

        console.log(data);
      } catch (err) {
        console.log(err);
        setLoading(false);

        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };
  const getInstitutionsAudit = async (activeTab) => {
    setLoading(true);

    try {
      const data = await ApiService.getInstitution(activeTab);
      console.log(data);
      setInstitutions(data?.data);
      setLoading(false);

      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };
  const subAdminTabs = [
    /*  {
        title: "Chief Admin",
        param: "chiefAdmin",
        route: "/audit-trail?tab=chiefAdmin",
      }, */
    {
      title: "Sub Admin 1",
      param: "subAdmin1",
      route: "/audit-trail?tab=subAdmin1",
    },
    {
      title: "Sub Admin 2",
      param: "subAdmin2",
      route: "/audit-trail?tab=subAdmin2",
    },
    {
      title: "Bank Admin",
      param: "bankAdmin",
      route: "/audit-trail?tab=bankAdmin",
    },
    {
      title: "Non Bank Admin",
      param: "nonBankAdmin",
      route: "/audit-trail?tab=nonBankAdmin",
    },
    {
      title: "Bank User 1",
      param: "bankUser1",
      route: "/audit-trail?tab=bankUser1",
    },
    {
      title: "Non Bank User 1",
      param: "nonBankUser1",
      route: "/audit-trail?tab=nonBankUser1",
    },
    {
      title: "Bank User 2",
      param: "bankUser2",
      route: "/audit-trail?tab=bankUser2",
    },
    {
      title: "Non Bank User 2",
      param: "nonBankUser2",
      route: "/audit-trail?tab=nonBankUser2",
    },
  ];

  const institutionTabs = [
    {
      title: "Bank Institutions",
      param: "bank",
      route: "/audit-trail?tab=bank",
    },
    {
      title: "Non Bank Institutions",
      param: "nonBank",
      route: "/audit-trail?tab=nonBank",
    },
  ];

  const auditTab = [
    { title: "Users", value: "user" },
    { title: "Institutions", value: "user" },
    { title: "Others", value: "user" },
  ];
  const { route } = Router();
  const [param] = useSearchParams();
  const activeTab = param.get("tab");

  //eslint-disable-next-line
  const [active, setActive] = useState("Users");

  // const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    if (active === "Institutions") {
      getInstitutionsAudit(`?institutionType=${activeTab}`);
      route(`/audit-trail?tab=${activeTab}`);
    }
    if (active === "Users") {
      getAdmins(`?adminType=${activeTab}`);
      route(`/audit-trail?tab=${activeTab}`);
    }
    //eslint-disable-next-line
  }, [activeTab]);

  useEffect(() => {
    if (active === "Institutions") {
      route(`/audit-trail?tab=${institutionTabs[0].param}`);
    }
    if (active === "Others") {
      getAuditOthers();
    }
    if (active === "Users") {
      route(`/audit-trail?tab=${subAdminTabs[0].param}`);
    }
    //eslint-disable-next-line
  }, [active]);
  useEffect(() => {
    if (active === "Users") {
      getAdmins(`?adminType=${subAdminTabs[0].param}`);
      route(`/audit-trail?tab=${subAdminTabs[0].param}`);
    }
    //eslint-disable-next-line
  }, []);

  return (
    <DashboardLayout>
      <AppTable
        tableHeadLength={
          (active === "Users" && "9") ||
          (active === "Institutions" && "6") ||
          (active === "Others" && "9")
        }
        tableHead={
          (active === "Users" && [
            "FIRSTNAME",
            "LASTNAME",
            "ID",
            "INSTITUTION",
            "EMAIL ADDRESS",
            "PHONE NUMBER",
            "DATE CREATED",
            "DATE DELETED",
            "DELETED BY",
          ]) ||
          (active === "Institutions" && [
            "institution name",
            "institution CODE",
            "institution contact email",
            "institution domain",
            "institution  users",
            "DATE CREATED",
          ]) ||
          (active === "Others" && [
            "ACTION",
            "Action by",
            "ID",
            "Action Date",
            "IP ADDRESS",
            "Browser",
            "OS",
            "Device",
            "HTTP METHOD",
          ])
        }
        btn={false}
        tableWidth={"fit-content"}
        titleB="Audit Trail"
        tabs={
          (active === "Users" && subAdminTabs) ||
          (active === "Institutions" && institutionTabs) ||
          (active === "Others" && [] === 0 && "")
        }
        columnWidth="200px"
        contentWidth="100px"
        param2={`adminType=${activeTab}`}
        action={getAdmins}
        transactions={admins}
        searchInput={searchInput}
        pagination={true}
        loading={loading}
        childrenHead={
          <div>
            <SearchInput
              width="200%"
              onChange={(e) => {
                getAdmins(
                  `?search=${e.target.value || ""}&adminType=${activeTab}`
                );
                setSearchInput(e.target.value);
              }}
            />
          </div>
        }
        tableContent={
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              alignItems: "center",
              margin: " 26px 0",
            }}
          >
            {auditTab?.map((item) => {
              return (
                <TabButton
                  active={active}
                  title={item?.title}
                  onClick={() => {
                    if (active === "Others") {
                      getAuditOthers();
                    }
                    if (active === "institutions") {
                      route("/audit-trail?tab=bank");
                      getInstitutionsAudit(
                        `?institutionType=${institutionTabs[0].param}`
                      );
                    }
                    if (active === "Users") {
                      route("/audit-trail?tab=subAdmin1");
                      getAdmins(`?adminType=${subAdminTabs[0].param}`);
                    }
                    setActive(item?.title);
                  }}
                />
              );
            })}
          </div>
        }
      >
        {/* {admins?.results?.length === 0 && (
          <div
            style={{
              color: "#a7a7a7",
              marginBottom: "40px",
              fontSize: "18px",
              textAlign: "center",
              width: "100%",
              padding: "20px",
            }}
          >
            No data here
          </div>
        )} */}
        {active === "Users" && (
          <TableBodyContent>
            {loading ? (
              <div style={{ width: "80vw" }}>
                <Skeleton2 height="500px" />
              </div>
            ) : (
              admins?.results?.map((item) => {
                return (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: `repeat(9, 200px)`,
                    }}
                    className="table_body_item"
                  >
                    <div>{item?.firstName || "-"}</div>
                    <div>{item?.lastName || "-"}</div>
                    <div>{item?.id}</div>
                    <div>{item?.userDetail?.institution?.name || "UP"}</div>
                    <div className="email">
                      {item?.email?.slice(0, 10)}...{" "}
                      <span style={{ position: "absolute" }}>
                        {item?.email || "-"}
                      </span>{" "}
                    </div>
                    <div>{item?.userDetail?.phoneNumber || "-"}</div>
                    <div>
                      {moment(item?.dateJoined)
                        .subtract(1, "hours")
                        .format("DD-MM-YYYY hh:mm")}
                    </div>
                    <div>
                      {moment(item?.userDetail?.deletedOn)
                        .subtract(1, "hours")
                        .format("DD-MM-YYYY hh:mm")}
                    </div>
                    <div
                      style={{
                        wordBreak: "break-word",
                      }}
                    >
                      {item?.userDetail?.deletedBy || "-"}
                    </div>
                  </div>
                );
              })
            )}
          </TableBodyContent>
        )}
        {active === "Institutions" && (
          <TableBodyContent>
            {loading ? (
              <div style={{ width: "80vw" }}>
                <Skeleton2 height="500px" />
              </div>
            ) : (
              institutions?.results
                ?.filter((x) => x?.institutionType === activeTab)
                ?.map((item, index) => {
                  return (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: `repeat(6, 200px)`,
                        alignItems: "center",
                      }}
                      className="table_body_item"
                    >
                      <div
                        style={{
                          cursor: "pointer",
                          wordBreak: "break-word",
                        }}
                        className="insName"
                      >
                        {item?.name || "-"}
                      </div>
                      <div>{item?.code || "-"}</div>
                      <div
                        style={{
                          wordBreak: "break-word",
                        }}
                        className="email"
                      >
                        {item?.supportEmails?.length &&
                          `${item?.supportEmails?.[0]}`}
                        {(item?.supportEmails?.length && (
                          <span style={{ position: "absolute" }}>
                            [ {item?.supportEmails?.join(", ")}]
                          </span>
                        )) ||
                          "-"}{" "}
                      </div>
                      <div>{item?.domain || "-"}</div>
                      <div>{item?.users?.length || "-"}</div>
                      <div>
                        {moment(item?.updatedOn)
                          .subtract(1, "hours")
                          .format("DD-MM-YYYY hh:mm")}
                      </div>
                    </div>
                  );
                })
            )}
          </TableBodyContent>
        )}
        {active === "Others" && (
          <TableBodyContent>
            {loading ? (
              <div style={{ width: "80vw" }}>
                <Skeleton2 height="500px" />
              </div>
            ) : (
              others?.results?.map((item) => {
                return (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: `repeat(9, 200px)`,
                    }}
                    className="table_body_item"
                  >
                    <div>{item?.action || "-"}</div>
                    <div>{item?.actionBy || "-"}</div>
                    <div>{item?.id}</div>
                    <div>
                      {moment(item?.createdOn)
                        .subtract(1, "hours")
                        .format("DD-MM-YYYY hh:mm")}
                    </div>
                    <div>{item?.sourceAddress || "-"}</div>
                    <div>{item?.browser || "-"}</div>
                    <div>{item?.system || "-"}</div>

                    <div>{item?.device || "-"}</div>
                    <div>{item?.method || "-"}</div>
                  </div>
                );
              })
            )}
          </TableBodyContent>
        )}
      </AppTable>
    </DashboardLayout>
  );
}
